<template>
  <el-dialog :title="finalTitle" :visible.sync="localVisible" :width="dialogWidth"
    class="import-dialog dialog-with-radius" :close-on-click-modal="closeOnClickModal" @close="handleClose">

    <!-- AI课程大纲转换工具弹窗 -->
    <HtmlEmbedDialog ref="aiCourseDialogRef" dialog-title="AI课程大纲转换工具" dialog-width="1400px"
      :html-path="aiCourseHtmlPath" :iframe-height="700" :query-params="aiCourseParams"
      @message="handleAiCourseMessage" />

    <!-- 上传区域 -->
    <div class="import-content" v-if="!importResult">
      <div class="import-header">
        <div class="import-actions">
          <!-- 下载模板 -->
          <el-button type="text" icon="el-icon-download" @click="downloadFile(finalTemplateUrl, templateText)"
            :loading="downloading">
            {{ templateBtnText }}
          </el-button>
          <!-- 上传按钮 -->
          <el-upload ref="uploadRef" class="import-upload" :action="uploadAction" :headers="uploadHeaders"
            :data="uploadData" :accept="acceptType" :show-file-list="false" :before-upload="beforeUpload"
            :on-success="handleUploadSuccess" :on-error="handleUploadError" :on-progress="handleUploadProgress" drag>
            <div class="upload-content">
              <i class="el-icon-upload"></i>
              <div class="upload-text">
                <p class="primary-text">将文件拖拽到此处，或<em>点击上传</em></p>
                <p class="secondary-text">支持 {{ acceptHint }} 格式</p>
              </div>
            </div>
          </el-upload>
          <!-- 上传进度 -->
          <el-progress v-if="uploading" :percentage="uploadProgress" :stroke-width="6"
            class="upload-progress"></el-progress>
        </div>
      </div>
    </div>

    <!-- 导入结果区域 -->
    <div class="import-result" v-else>
      <!-- 结果摘要 -->
      <div class="result-summary">
        <div class="summary-item success">
          <i class="el-icon-success"></i>
          <span class="label">成功</span>
          <span class="count">{{ successData.length || successTotle }}</span>
        </div>
        <div class="summary-item fail" v-if="failData.length > 0">
          <i class="el-icon-error"></i>
          <span class="label">失败</span>
          <span class="count">{{ failData.length || failTotal }}</span>
        </div>
      </div>

      <!-- 成功数据表格 -->
      <div class="result-table" v-if="successData.length > 0">
        <div class="table-header">
          <span>{{ successTableTitle }}</span>
        </div>
        <aj-table ref="successTableRef" :data="successData" :columns="successColumns"
          :use-internal-pagination="useInternalPagination" :currentPage.sync="successPage" :pageSize="pageSize"
          :total="successData.length" :row-id-key="successRowIdKey" size="small">
          <!-- 透传成功表格的插槽 -->
          <template v-for="(_, name) in $scopedSlots" #[name]="scope">
            <slot :name="name" v-bind="{ ...scope, type: 'success' }"></slot>
          </template>
        </aj-table>
      </div>

      <!-- 失败数据表格 -->
      <div class="result-table" v-if="failData.length > 0">
        <div class="table-header">
          <span>{{ failTableTitle }}</span>
          <el-button type="text" icon="el-icon-download" :loading="exportingFailData" @click="handleExportFailData">
            导出失败数据
          </el-button>
        </div>
        <aj-table ref="failTableRef" :data="failData" :columns="failColumns"
          :use-internal-pagination="useInternalPagination" :currentPage.sync="failPage" :pageSize="pageSize"
          :total="failData.length" :row-id-key="failRowIdKey" size="small">
          <!-- 透传失败表格的插槽 -->
          <template v-for="(_, name) in $scopedSlots" #[name]="scope">
            <slot :name="name" v-bind="{ ...scope, type: 'fail' }"></slot>
          </template>
        </aj-table>
      </div>
    </div>

    <!-- 弹窗底部 -->
    <template #footer>
      <div class="dialog-footer">
        <!-- 自定义按钮区域 -->
        <div class="custom-footer-left" v-if="$scopedSlots.footer">
          <slot name="footer" :importResult="importResult" :successData="successData" :failData="failData"></slot>
        </div>
        <div class="footer-actions">
          <el-button v-if="importResult && showBackBtn" @click="handleBack">
            <i class="el-icon-back"></i> 返回上传
          </el-button>
          <el-button @click="handleClose">
            {{ importResult ? closeBtnText : '取消' }}
          </el-button>
          <el-button v-if="showAiExtractBtn" @click="handleAiExtract">
            AI提取文档转Excel
          </el-button>
          <el-button v-if="!importResult && showConfirmBtn" type="primary" @click="handleConfirm" :disabled="!hasFile">
            {{ confirmBtnText }}
          </el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { exportFile } from '../../api/api';
import envConfig from '../../api/env.js';
import HtmlEmbedDialog from './HtmlEmbedDialog.vue';
import axios from 'axios';
import qs from 'qs';

export default {
  name: 'BatchImportDialog',
  components: {
    HtmlEmbedDialog
  },
  props: {
    isSucess: {

      type: Boolean,

      default: false

    },
    // 下载模板文件名称
    templateText: {
      type: String,
      default: '导入模板'
    },
    // 弹窗标题
    title: {
      type: String,
      default: '批量导入'
    },
    // 弹窗宽度
    dialogWidth: {
      type: [String, Number],
      default: '800px'
    },
    // 是否显示
    visible: {
      type: Boolean,
      required: true
    },
    // 是否点击遮罩层关闭
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    // 基础URL（用于外部地址）
    baseURL: {
      type: String,
      default: ''
    },
    // 上传接口地址（相对路径）
    uploadUrl: {
      type: String,
      required: true
    },
    // 上传接口额外参数
    uploadData: {
      type: Object,
      default: () => ({})
    },
    // 下载模板接口地址（可以是相对路径或完整URL）
    templateUrl: {
      type: String,
      default: ''
    },
    // 下载模板接口参数
    templateData: {
      type: Object,
      default: () => ({})
    },
    // 下载模板按钮文字
    templateBtnText: {
      type: String,
      default: '下载模板'
    },
    // 接受的文件类型
    acceptType: {
      type: String,
      default: '.xlsx,.xls'
    },
    // 接受的文件类型提示
    acceptHint: {
      type: String,
      default: 'xlsx、xls'
    },
    // 是否显示确认按钮
    showConfirmBtn: {
      type: Boolean,
      default: false
    },
    // 确认按钮文字
    confirmBtnText: {
      type: String,
      default: '确认导入'
    },
    // 是否显示AI提取按钮（默认显示，课程中心页面可设为false隐藏）
    showAiExtractBtn: {
      type: Boolean,
      default: true
    },
    // 关闭按钮文字
    closeBtnText: {
      type: String,
      default: '关闭'
    },
    // 是否显示返回上传按钮
    showBackBtn: {
      type: Boolean,
      default: true
    },
    // 最大上传文件大小(MB)
    maxFileSize: {
      type: Number,
      default: 10
    },
    // 成功表格标题
    successTableTitle: {
      type: String,
      default: '成功数据'
    },
    // 失败表格标题
    failTableTitle: {
      type: String,
      default: '失败原因'
    },
    // 成功表格列配置
    successColumns: {
      type: Array,
      default: () => []
    },
    // 失败表格列配置
    failColumns: {
      type: Array,
      default: () => []
    },
    // 接口返回数据中成功数据的字段名
    successDataKey: {
      type: String,
      default: 'successData'
    },
    // 接口返回数据中失败数据的字段名
    failDataKey: {
      type: String,
      default: 'failData'
    },
    // 是否使用内部分页
    useInternalPagination: {
      type: Boolean,
      default: true
    },
    // 分页大小
    pageSize: {
      type: Number,
      default: 10
    },
    // 成功表格行ID键名
    successRowIdKey: {
      type: String,
      default: 'id'
    },
    // 失败表格行ID键名
    failRowIdKey: {
      type: String,
      default: 'rowNum'
    }
  },
  data() {
    return {
      successTotle: 0,
      failTotal: 0,
      localVisible: this.visible,
      uploading: false,
      uploadProgress: 0,
      hasFile: false,
      fileName: '',
      downloading: false,
      importResult: null,
      failPage: 1,
      successPage: 1,
      // AI课程大纲工具配置
      aiCourseHtmlPath: 'muBan/aicourse_word_to_json/index.html',
      aiCourseParams: {},
      // 失败数据导出key
      temKey: null,
      exportingFailData: false
    };
  },
  computed: {
    finalTitle() {
      return this.importResult ? `${this.title}结果` : this.title;
    },
    uploadHeaders() {
      return {
        'userourage': window.localStorage.getItem('zhikeTong_token') || ''
      };
    },
    // 上传完整地址
    uploadAction() {
      const base = envConfig.baseURL;
      console.log(base);
      return base + this.uploadUrl;
    },
    // 模板完整地址
    finalTemplateUrl() {
      if (!this.templateUrl) return '';
      // 如果已经是完整地址（http开头）
      if (this.templateUrl.startsWith('http://') || this.templateUrl.startsWith('https://')) {
        return this.templateUrl;
      }
      // 否则拼接基础URL
      const base = this.baseURL || envConfig.default?.baseURL || '';
      return base + this.templateUrl;
    },
    // 获取成功数据
    successData() {
      if (!this.importResult) return [];
      const data = this.importResult
      console.log(data, this.importResult);

      return this.isSucess ? data : [];
    },
    // 获取失败数据
    failData() {
      if (!this.importResult) return [];
      const data = this.importResult;
      return this.isSucess ? [] : data;
    }
  },
  watch: {
    visible(newVal) {
      this.localVisible = newVal;
      if (newVal) {
        this.resetState();
      }
    }
  },
  methods: {
    // AI提取文档转Excel
    handleAiExtract() {
      const token = window.localStorage.getItem('zhikeTong_token') || '';
      // 直接传入参数，避免 Vue 响应式延迟问题
      this.$refs.aiCourseDialogRef.open({
        userourage: token
      });
      this.$emit('ai-extract');
    },

    // 处理来自AI课程工具的消息
    handleAiCourseMessage(data) {
      console.log('🔵 收到AI课程工具消息:', data);
      console.log('🔵 消息类型:', data ? data.type : '无type');
      this.$emit('ai-course-message', data);

      // 监听上传课程事件
      if (data && data.type === 'uploadCourses') {
        const payload = data.payload;
        console.log('📤 收到上传课程数据:', payload);
        console.log('📤 课程数量:', payload.courseCount);

        // 弹框确认是否导入
        this.$confirm(`确定要导入 ${payload.courseCount} 条课程数据吗？`, '确认导入', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(async () => {
          console.log('✅ 用户点击确定，开始上传到服务端');

          try {
            // 调用上传接口
            const response = await this.uploadCoursesToServer(payload);
            console.log(response);

            this.importResult = response.data;
            this.successTotle = response.item || '0'
            // 上传成功后关闭 AI 工具弹框
            this.$refs.aiCourseDialogRef.close();

            // 触发上传成功事件，通知父组件刷新列表
            const eventData = {
              fileName: payload.fileName,
              result: payload.data,
              successData: payload.data,
              failData: []
            };

            this.$emit('upload-success', eventData);

            this.$message.success(`成功导入 ${payload.courseCount} 条课程数据`);
          } catch (error) {
            console.error('❌ 上传失败:', error);
            this.$message.error(`上传失败: ${error.message || '请稍后重试'}`);
          }
        }).catch(() => {
          // 用户点击取消
          console.log('❌ 用户取消导入');
        });

        // 同时触发事件给父组件
        this.$emit('ai-upload-courses', payload);
      }

      // 示例：监听导出成功事件，关闭弹窗并提示
      if (data.type === 'exportComplete') {
        this.$message.success('Excel导出成功！');
      }
      if (data.type === 'importSuccess') {
        this.$message.success('导入成功！');
        // 可以在这里触发刷新列表等操作
        this.$emit('ai-import-success', data.payload);
      }
    },

    // 上传课程数据到服务端
    async uploadCoursesToServer(payload) {
      const token = window.localStorage.getItem('zhikeTong_token') || '';
      const uploadUrl = envConfig.baseURL + this.uploadUrl;

      console.log('📤 开始上传到服务端:', uploadUrl);
      console.log('📤 上传数据条数:', payload.data.length);

      // 创建 FormData，将 Excel Blob 作为文件上传
      const formData = new FormData();
      formData.append('file', payload.excelBlob, payload.fileName);

      const response = await axios.post(uploadUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'userourage': token
        }
      });

      console.log('📥 服务端响应:', response.data);

      if (response.data && response.data.status === 200) {
        return response.data;
      } else {
        throw new Error(response.data?.msg || '上传失败');
      }
    },

    // 重置状态
    resetState() {
      this.hasFile = false;
      this.fileName = '';
      this.importResult = null;
      this.uploading = false;
      this.uploadProgress = 0;
      this.failPage = 1;
      this.successPage = 1;
      this.temKey = null;
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles();
      }
    },

    // 上传前校验
    beforeUpload(file) {
      const isExcel = this.acceptType.split(',').some(ext => {
        return file.name.toLowerCase().endsWith(ext.trim().toLowerCase());
      });
      const isLtSize = file.size / 1024 / 1024 < this.maxFileSize;

      if (!isExcel) {
        this.$message.error(`只能上传 ${this.acceptHint} 格式文件!`);
        return false;
      }
      if (!isLtSize) {
        this.$message.error(`文件大小不能超过 ${this.maxFileSize}MB!`);
        return false;
      }

      this.uploading = true;
      this.uploadProgress = 0;
      // 显示loading
      this.$loading.show();
      return true;
    },

    // 上传进度
    handleUploadProgress(event) {
      this.uploadProgress = Math.round(event.percent);
    },

    // 上传成功
    handleUploadSuccess(response, file, fileList) {
      // 关闭loading
      this.$loading.close();
      this.uploading = false;
      this.hasFile = true;
      this.fileName = file.name;

      if (response && response.status === 200) {
        // 解析返回结果
        this.importResult = typeof response.data === 'string'
          ? JSON.parse(response.data)
          : response.data;
        this.successTotle = response.item || '0';
        this.temKey = response.tem || null;
        this.$message.success('上传成功');
        // 触发上传完成事件
        this.$emit('upload-success', {
          fileName: this.fileName,
          result: this.importResult,
          successData: this.successData,
          failData: this.failData
        });
      } else {
        this.$message.error(response.msg || '导入失败');
        this.$emit('upload-error', response);
      }
    },

    // 上传失败
    handleUploadError(err) {
      // 关闭loading
      this.$loading.close();
      this.uploading = false;
      console.error('上传失败:', err);
      this.$message.error('上传失败，请稍后重试');
      this.$emit('upload-error', err);
    },

    // 下载模板
    downloadFile(url, name) {
      //下载
      if (!url) {
        return;
      }
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.onload = function () {
        document.body.removeChild(link);
      };
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
    },

    // 返回上传
    handleBack() {
      this.importResult = null;
      this.hasFile = false;
      this.fileName = '';
      this.failPage = 1;
      this.successPage = 1;
    },

    // 确认导入
    handleConfirm() {
      if (!this.hasFile) {
        this.$message.warning('请先上传文件');
        return;
      }
      this.$emit('confirm', {
        fileName: this.fileName,
        result: this.importResult,
        successData: this.successData,
        failData: this.failData
      });
    },

    // 关闭弹窗
    handleClose() {
      this.resetState();
      this.localVisible = false;
      this.$emit('update:visible', false);
      this.$emit('close');
    },

    // 对外暴露：打开弹窗
    open() {
      this.resetState();
      this.localVisible = true;
      this.$emit('update:visible', true);
    },

    // 对外暴露：关闭弹窗
    close() {
      this.handleClose();
    },

    // 对外暴露：设置导入结果（适用于手动调用接口的场景）
    setImportResult(result) {
      this.importResult = result;
    },

    // 对外暴露：获取成功数据
    getSuccessData() {
      return this.successData;
    },

    // 对外暴露：获取失败数据
    getFailData() {
      return this.failData;
    },

    // 导出失败数据
    async handleExportFailData() {
      if (!this.temKey) {
        this.$message.warning('没有可导出的失败数据');
        return;
      }

      this.exportingFailData = true;
      try {
        await exportFile('/ajCourse/exportAjCourseUploadTem', qs.stringify({ temKey: this.temKey }), '失败数据');
        this.$message.success('导出成功');
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error('导出失败，请稍后重试');
      } finally {
        this.exportingFailData = false;
      }
    }
  }
};
</script>

<style scoped>
/* 弹窗整体样式 */
.import-dialog ::v-deep .el-dialog {
  border-radius: 20px !important;
  overflow: hidden !important;
}

.import-dialog ::v-deep .el-dialog__header {
  background-color: #EFF5FF !important;
  padding: 16px 20px;
  border-bottom: 1px solid #f5f5f5;
}

.import-dialog ::v-deep .el-dialog__title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.import-dialog ::v-deep .el-dialog__headerbtn {
  top: 18px;
}

.import-dialog ::v-deep .el-dialog__body {
  padding: 0;
  max-height: calc(100vh - 150px);
  overflow-y: auto;
}

.import-dialog ::v-deep .el-dialog__footer {
  padding: 12px 20px;
  border-top: 1px solid #f5f5f5;
  text-align: right;
  background-color: #F9FAFB;
}

/* 上传区域 */
.import-content {
  padding: 20px;
}

.import-header {
  display: flex;
  justify-content: center;
}

.import-actions {
  width: 100%;
  max-width: 450px;
}

/* 下载模板按钮 */
.import-actions .el-button--text {
  color: #1890ff;
  font-size: 14px;
  padding: 0;
  margin-bottom: 16px;
}

.import-actions .el-button--text:hover {
  color: #40a9ff;
}

/* 上传组件 */
.import-upload {
  width: 100%;
}

.import-upload ::v-deep .el-upload {
  width: 100%;
}

.import-upload ::v-deep .el-upload-dragger {
  width: 100%;
  height: auto;
  padding: 40px 20px;
  border-radius: 8px;
  border: 1px dashed #d9d9d9;
  background-color: #fafafa;
  transition: all 0.3s;
}

.import-upload ::v-deep .el-upload-dragger:hover {
  border-color: #1890ff;
  background-color: #fff;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.upload-content .el-icon-upload {
  font-size: 48px;
  color: #1890ff;
  margin-bottom: 12px;
}

.upload-text {
  text-align: center;
}

.upload-text .primary-text {
  font-size: 14px;
  color: #333;
  margin: 0 0 8px;
}

.upload-text .primary-text em {
  color: #1890ff;
  font-style: normal;
  cursor: pointer;
}

.upload-text .secondary-text {
  font-size: 12px;
  color: #999;
  margin: 0;
}

/* 上传进度 */
.upload-progress {
  margin-top: 16px;
  padding: 0 10px;
}

.upload-progress ::v-deep .el-progress__text {
  font-size: 12px !important;
  min-width: 35px;
}

/* 导入结果区域 */
.import-result {
  padding: 20px;
}

/* 结果摘要 */
.result-summary {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 20px;
  padding: 16px;
  background-color: #f5f7fa;
  border-radius: 8px;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.summary-item.success .el-icon-success {
  font-size: 20px;
  color: #52c41a;
}

.summary-item.fail .el-icon-error {
  font-size: 20px;
  color: #ff4d4f;
}

.summary-item .label {
  font-size: 14px;
  color: #666;
}

.summary-item .count {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.summary-item.success .count {
  color: #52c41a;
}

.summary-item.fail .count {
  color: #ff4d4f;
}

/* 表格区域 */
.result-table {
  margin-top: 16px;
}

.result-table:first-child {
  margin-top: 0;
}

.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: #f5f7fa;
  border-radius: 6px 6px 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

/* 弹窗底部 */
.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-footer-left {
  flex: 1;
}

.footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.footer-actions .el-button {
  min-width: 80px;
}

.footer-actions .el-button--primary {
  background-color: #1890ff;
  border-color: #1890ff;
}

.footer-actions .el-button i {
  margin-right: 4px;
}

/* 滚动条样式 */
.import-dialog ::v-deep .el-dialog__body::-webkit-scrollbar {
  width: 6px;
}

.import-dialog ::v-deep .el-dialog__body::-webkit-scrollbar-thumb {
  background-color: #dcdcdc;
  border-radius: 3px;
}

.import-dialog ::v-deep .el-dialog__body::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}

/* AI课程工具 iframe 容器样式 */
.import-dialog ::v-deep .detail-dialog-body {
  padding: 0 !important;
  height: auto;
  overflow: visible;
}

.import-dialog ::v-deep .iframe-container {
  height: 700px !important;
  min-height: 700px !important;
  overflow: hidden;
}

.import-dialog ::v-deep .iframe-container iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
